// extracted by mini-css-extract-plugin
module.exports = {"root":"ModifySelectedRooms_root__29tfO","closeButton":"ModifySelectedRooms_closeButton__3Hmta"};